import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PlatformApplicationAlert } from "./system-message.model";

@Injectable({ providedIn: "root" })
export class SystemMessagesService {
    private httpClient = inject(HttpClient);

    getAll(): Observable<PlatformApplicationAlert[]> {
        return this.httpClient.get<PlatformApplicationAlert[]>(this.messagesUrl());
    }

    private messagesUrl(): string {
        return "/api/platform/messages";
    }
}
